document.addEventListener("DOMContentLoaded", () => {

  console.log("Editorial Look Loaded");

  document.querySelectorAll(".editorial-product-card").forEach(initCard);

});

function initCard(card) {

  const variants = JSON.parse(
    card.querySelector(".editorial-product-card__variants").textContent
  );

  const imageWrapper = card.querySelector("[data-image-wrapper]");
  const addButton = card.querySelector("[data-add-to-cart]");

  const optionInputs = card.querySelectorAll(".radios--input");

  optionInputs.forEach(input => {

    input.addEventListener("change", () => {
      updateCard(card, variants);
    });

  });

  updateCard(card, variants);

  if (addButton) {

    addButton.addEventListener("click", async (e) => {

        e.preventDefault();

        const button = card.querySelector("[data-add-to-cart]");
        const id = Number(button.dataset.variantId);

        
        

        try {

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id,
                    quantity: 1
                })
            });

            

            if (!response.ok) {
                throw new Error(await response.text());
            }

            const data = await response.json();

            

            // 🔥 Refresh Blockshop cart
            await theme.cart.fetchTotals();
            await theme.cart.updateAllHtml(true);

        } catch (err) {

            console.error("FETCH ERROR:", err);

        }

    });

}

  function updateCard(card,variants){
   

      const selected = [];

card.querySelectorAll(".product-options--option").forEach((optionGroup, index) => {

    const checked = optionGroup.querySelector(".radios--input:checked");

    selected[index] = checked ? checked.value : null;

});

updateOptionAvailability(card, variants, selected);
      

      const variant = variants.find(v => {

    if (selected[0] && v.option1 !== selected[0]) return false;
    if (selected[1] && v.option2 !== selected[1]) return false;
    if (selected[2] && v.option3 !== selected[2]) return false;

    return true;

});

      if(!variant) return;

      console.log("Matched Variant",variant);

     

      //----------------------------------
      // IMAGE
      //----------------------------------

      const template=card.querySelector(
          `[data-image-template="${variant.id}"]`
      );

      if(template && imageWrapper){

          imageWrapper.innerHTML=template.innerHTML;

      }

      //----------------------------------
      // PRICE
      //----------------------------------

      const original=card.querySelector(".product-price--original");

      if(original){

          original.innerHTML=new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
}).format(variant.price / 100);

      }

      //----------------------------------
      // COMPARE
      //----------------------------------

      const compare=card.querySelector(".product-price--compare");

      if(compare){

          if(
              variant.compare_at_price &&
              variant.compare_at_price>variant.price
          ){

              compare.style.display="";

              compare.innerHTML=new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
}).format(variant.compare_at_price / 100);

          }else{

              compare.style.display="none";

          }

      }

      //----------------------------------
      // BUTTON
      //----------------------------------

      if (addButton) {

    

    addButton.dataset.variantId = variant.id;

    

    addButton.disabled = !variant.available;

    addButton.textContent = variant.available
        ? "Add to Cart"
        : "Sold Out";

}

  }

  function updateOptionAvailability(card, variants, selected) {

    const optionGroups = card.querySelectorAll(".product-options--option");

    optionGroups.forEach((group, optionIndex) => {

        group.querySelectorAll(".radios--input").forEach(input => {

            // Copy current selection
            const testSelection = [...selected];

            // Pretend this option is selected
            testSelection[optionIndex] = input.value;

            // Check if an AVAILABLE variant exists
            const exists = variants.some(v => {

                if (!v.available) return false;

                if (testSelection[0] && v.option1 !== testSelection[0]) return false;
                if (testSelection[1] && v.option2 !== testSelection[1]) return false;
                if (testSelection[2] && v.option3 !== testSelection[2]) return false;

                return true;

            });

            input.disabled = !exists;

        });

    });

}

}